// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1LIw2","rootMobile":"styles_rootMobile__JV2xi"};